import { Observable, of, throwError } from "rxjs";
import { Router } from '@angular/router';
import { AccountService } from '../services/AccountService';

export class utility {
    public static RowsPerPageOptions: number[] = [10, 25, 50];
    public static accountService: AccountService;

    public static FormatDate(input): string {
        if (input == null)
            return '';
        var dateinput = new Date(input);
        var result = dateinput.toLocaleString();
        return result;
    }

    //this return only date
    public static FormatDateOnly(input): string {
        if (input == null)
            return '';
        var dateinput = new Date(input);
        var result = (dateinput.getMonth() + 1) + '/' + dateinput.getDate() + '/' + dateinput.getFullYear();
        return result;
    }


    //Use the UTC when getting data from database
    public static FormatUTCDate(input): string {
        if (input == null)
            return '';
        var dateinput = new Date(input);
        var offset = dateinput.getTimezoneOffset() / 60;
        var hours = dateinput.getHours();
        dateinput.setHours(hours - offset);
        var result = dateinput.toLocaleString();
        return result;
    }

    //this return only date
    public static FormatUTCDateOnly(input): string {
        if (input == null)
            return '';
        var dateinput = new Date(input);
        var offset = dateinput.getTimezoneOffset() / 60;
        var hours = dateinput.getHours();
        dateinput.setHours(hours - offset);
        var result = (dateinput.getMonth() + 1) + '/' + dateinput.getDate() + '/' + dateinput.getFullYear();
        return result;
    }


    public static AddSpaces(input): string {
        return input.replace(/([a-z])([A-Z])/g, '$1 $2');
    }

    public static FormatPhoneNumber(input): string {
        if (input == null) { return ''; }

        var value = input.toString().trim().replace(/^\+/, '');

        if (value.match(/[^0-9]/)) {
            return input;
        }

        var country, city, number;

        switch (value.length) {
            case 10: // +1PPP####### -> C (PPP) ###-####
                country = 1;
                city = value.slice(0, 3);
                number = value.slice(3);
                break;

            case 11: // +CPPP####### -> CCC (PP) ###-####
                country = value[0];
                city = value.slice(1, 4);
                number = value.slice(4);
                break;

            case 12: // +CCCPP####### -> CCC (PP) ###-####
                country = value.slice(0, 3);
                city = value.slice(3, 5);
                number = value.slice(5);
                break;

            default:
                return input;
        }

        if (country == 1) {
            country = "";
        }

        number = number.slice(0, 3) + '-' + number.slice(3);

        return (country + " (" + city + ") " + number).trim();
    }

    public static cloneObject(obj: any): any {
        let res = {};
        for (let prop in obj) {
            res[prop] = obj[prop];
        }
        return res;
    }

    //Helps in JSON deserialization
    public static convertToInstance<T>(obj: T, json: string): T {
        var jsonObj = JSON.parse(json);

        if (typeof obj["fromJSON"] === "function") {
            obj["fromJSON"](jsonObj);
        }
        else {
            for (var propName in jsonObj) {
                obj[propName] = jsonObj[propName]
            }
        }

        return obj;
    }

    public static getObjectLabel(obj) {
        if (obj != null)
            return obj.label;
        else
            return '';
    }

    public static removeSlash(input: string) {
        if (input == null || input == undefined)
            return input;

        return input.replace(/\//g, ' ');
    }

    public static MaskDate(event) {
        if (event.currentTarget != null && event.currentTarget.value != null) {
            var value = event.currentTarget.value;
            if (value.substr(value.length - 1) != '/') {
                if (value != null && (value.length == 3)) {
                    value = [value.slice(0, 2), '/', value.slice(2)].join('');
                    event.currentTarget.value = value;
                } else if (value != null && (value.length == 6)) {
                    value = [value.slice(0, 5), '/', value.slice(5)].join('');
                    event.currentTarget.value = value;
                }
            }
        }
    }

    public static formatPhoneNumber(phoneNumberString) {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
        if (match) {
            var intlCode = (match[1] ? '+1 ' : '')
            return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
        }
        return null
    }

    public static getExtension(path) {
        var basename = path.split(/[\\/]/).pop(),  // extract file name from full path ...
                                                   // (supports `\\` and `/` separators)
            pos = basename.lastIndexOf(".");       // get last position of `.`
    
        if (basename === "" || pos < 1)            // if file name is empty or ...
            return "";                             //  `.` not found (-1) or comes first (0)
    
        return basename.slice(pos + 1);            // extract extension ignoring `.`
    }

    public static getDocumentIconClass(doc: any): string
    {
        if(doc.FileTypeID == 7)
        {
            return "fiv-cla fiv-icon-browser";
        }
        else
        {
             let ext = this.getExtension(doc.Title);
             if(ext === "")
             {
                  return "fiv-cla fiv-icon-blank";
             }
             else
             {
                return "fiv-cla fiv-icon-" + ext;
             }
        }
        
    }
    
    public static OpenURl(url:string)
    {
        if (!url.match(/^http?:\/\//i) && !url.match(/^https?:\/\//i)) {
            url = 'http://' + url;
        }
        window.open(url, "_blank");
    }
    public static handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            if (error.status == 401 && error.error === 'No Current User') {
                utility.accountService.LogOut();
            }else if (error.status == 401 && error.statusText == 'Unauthorized') {
                window.location.href = '#/unauthorized';
            }
            console.log("Error occurred in ", operation);
            console.log(error);
            var errorMessage = error.error.Message;
            throw new error(error);
        }
    }

    public static handleErrorNew(error): Observable<any> {
        console.log(error);
        var errorMessage = error.error.Message;
        if (error.status == 401 && error.statusText == 'Unauthorized') {
            window.location.href = '#/unauthorized';
        }
        return throwError(errorMessage);
    }

    public static fixCalendarDate(date: any): string {
        var result = '';
        if (date != null && this.FormatDate(date) != '')
            result = new Date(date).toLocaleDateString();

        return result;
    }

    public static removeHTML(str):string{ 
        var tmp = document.createElement("DIV");
        tmp.innerHTML = str;
        return tmp.textContent || tmp.innerText || "";
    }

    public static formatURLForDisplay(url:string):string{
        var result = url.replace(/(^\w+:|^)\/\//, '');
        return result;
    }
    public static formatUrl(url:any)
    {
      if (!/^https?:\/\//i.test(url)) {
        url = 'https://' + url;
       
       }
       return url
    }
}
